import { writable } from "../utils/stores";
export const communityPreviewOriginStore = writable(undefined);
